import {
  FunctionComponent,
  ImgHTMLAttributes,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import cn from 'classnames';
import './LoadingImage.scss';

interface Props extends ImgHTMLAttributes<HTMLImageElement> {
  className?: string;
}

export const LoadingImage: FunctionComponent<Props> = ({ src, alt, className, ...rest }) => {
  const [isLoading, setIsLoading] = useState(false);
  const ref = useRef<HTMLImageElement | null>(null);

  const handleImageLoaded = useCallback(() => {
    setIsLoading(false);
  }, [setIsLoading]);

  useEffect(() => {
    setIsLoading(!ref.current?.complete);
  }, [src]);

  return (
    <img
      {...rest}
      className={cn(className, 'loading-image', {
        'loading-image--loading': isLoading,
      })}
      onLoad={handleImageLoaded}
      src={src}
      ref={ref}
      alt={alt}
    />
  );
};
